const btnClassesRem = 'btn-primary btn-secondary btn-buy outline btn-pop btn-pulse';

// ------------------------------------
// BOTÕES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'css-variables';
    const ref2 = 'general';

    // Formato dos botões
    function changeBtnRadius() {
      const value = confTheme[ref]['btn-radius'];
      $root[0].style.setProperty('--btn-radius', value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-radius', changeBtnRadius);

    // Botão primário estilo
    function changeBtnPrimaryStyle() {
      const value = confTheme[ref2]['btn-primary-style'];
      const $elements = $('.btn-primary');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-style', changeBtnPrimaryStyle);

    // Botão primário animação
    function changeBtnPrimaryAni() {
      const value = confTheme[ref2]['btn-primary-animation'];
      const $elements = $('.btn-primary');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-animation', changeBtnPrimaryAni);

    // Botão secundário estilo
    function changeBtnSecondaryStyle() {
      const value = confTheme[ref2]['btn-secondary-style'];
      const $elements = $('.btn-secondary');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-style', changeBtnSecondaryStyle);

    // Botão secundário animação
    function changeBtnSecondaryAni() {
      const value = confTheme[ref2]['btn-secondary-animation'];
      const $elements = $('.btn-secondary');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-animation', changeBtnSecondaryAni);

    // Botão de compra estilo
    function changeBtnBuyStyle() {
      const value = confTheme[ref2]['btn-buy-style'];
      const $elements = $('.btn-buy');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-style', changeBtnBuyStyle);

    // Botão de compra animação
    function changeBtnBuyAni() {
      const value = confTheme[ref2]['btn-buy-animation'];
      const $elements = $('.btn-buy');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-animation', changeBtnBuyAni);
  }
})();
